import React from 'react';
import { Field } from 'redux-form';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from 'helpers/reduxFormMaterialUiNext/Switch';

import Header from 'components/shared/Header';
import Collapsible from 'components/shared/Collapsible';

import { colors } from 'helpers/ColorHelper';
import { localize } from 'react-localize-redux';
import { serviceRequestOptions } from 'helpers/VerbiageHelper';
import { featureEnabled } from 'helpers/ToggleBot';

class PermissionFields extends React.Component {
  translateText = text => this.props.translate(text).props.children;

  render() {
    const { onChange } = this.props;

    const serviceRequestsOptions = {
      serviceRequest: this.translateText('landlordPortal.permissionFields.serviceRequests'),
      requestForMaintenance: this.translateText(
        'landlordPortal.permissionFields.serviceRequestsRFM'
      ),
    };

    return (
      <div>
        <Header
          name={this.translateText('landlordPortal.permissionFields.permissionHeader')}
          style={{ margin: '15px -20px 10px -20px' }}
        />

        <div className="row" style={{ marginTop: '10px' }}>
          <div className="col-sm-12">
            <PermissionField
              name="dashboard"
              label={this.translateText('landlordPortal.permissionFields.dashboard')}
              onChange={onChange}
            />

            <PermissionHeader name={this.translateText('landlordPortal.permissionFields.insights')}>
              <PermissionField
                name="reporting"
                label={this.translateText('landlordPortal.permissionFields.reporting')}
                onChange={onChange}
              />
              <PermissionField
                name="rules"
                label={this.translateText('landlordPortal.permissionFields.rules')}
                onChange={onChange}
              />
              <PermissionField
                name="insight_dashboards"
                label={this.translateText('landlordPortal.sideBar.insightDashboards')}
                onChange={onChange}
              />
            </PermissionHeader>
            <PermissionHeader
              name={this.translateText('landlordPortal.permissionFields.prospects')}
            >
              <PermissionField
                name="prospects"
                label={this.translateText('landlordPortal.permissionFields.prospects')}
                onChange={onChange}
              />
              <PermissionField
                name="showings"
                label={this.translateText('landlordPortal.permissionFields.showings')}
                onChange={onChange}
              />
              <PermissionField
                name="referrals"
                label={this.translateText('landlordPortal.permissionFields.referrals')}
                onChange={onChange}
              />
            </PermissionHeader>

            <PermissionField
              name="applications"
              label={this.translateText('landlordPortal.permissionFields.applications')}
              onChange={onChange}
            />
            <PermissionField
              name="rent_roll"
              label={this.translateText('landlordPortal.permissionFields.rentRoll')}
              onChange={onChange}
            />
            <PermissionField
              name="tenants"
              label={this.translateText('landlordPortal.permissionFields.tenants')}
              onChange={onChange}
            />

            <PermissionHeader
              name={this.translateText('landlordPortal.permissionFields.maintenance')}
            >
              <PermissionField
                name="maintenance"
                label={this.translateText('landlordPortal.permissionFields.maintenance')}
                onChange={onChange}
              />
              <PermissionField
                name="recurring_tickets"
                label={this.translateText('landlordPortal.permissionFields.recurringTickets')}
                onChange={onChange}
              />
              <PermissionField
                name="ticket_scheduler"
                label={this.translateText('landlordPortal.permissionFields.ticketScheduler')}
                onChange={onChange}
              />
              {featureEnabled('purchase_order') ? (
                <PermissionField
                  name="purchase_orders"
                  label={this.translateText('landlordPortal.permissionFields.purchaseOrder')}
                  onChange={onChange}
                />
              ) : (
                <React.Fragment />
              )}
              {featureEnabled('ui.maintenance.new_tickets_ui') ? (
                <PermissionField
                  name="projects"
                  label={this.translateText('landlordPortal.permissionFields.project')}
                  onChange={onChange}
                />
              ) : (
                <React.Fragment />
              )}
              <PermissionField
                name="assets"
                label={this.translateText('landlordPortal.permissionFields.assets')}
                onChange={onChange}
              />
              <PermissionField
                name="vendors"
                label={this.translateText('landlordPortal.permissionFields.vendors')}
                onChange={onChange}
              />
              <PermissionField
                name="inspections"
                label={this.translateText('landlordPortal.permissionFields.inspections')}
                onChange={onChange}
              />
              <PermissionField
                name="inspection_templates"
                label={this.translateText('landlordPortal.permissionFields.inspectionTemplates')}
                onChange={onChange}
              />
              <PermissionField
                name="escalation"
                label={this.translateText('landlordPortal.permissionFields.escalation')}
                onChange={onChange}
              />
            </PermissionHeader>

            {featureEnabled('yuhu_pay_v2') ? (
              <PermissionField
                name="batches"
                label={this.translateText('landlordPortal.permissionFields.batches')}
                onChange={onChange}
              />
            ) : null}

            {featureEnabled('internal_lease_charge_creation') ? (
              <PermissionField
                name="charges"
                label={this.translateText('landlordPortal.permissionFields.leaseCharges')}
                onChange={onChange}
              />
            ) : null}

            <PermissionHeader
              name={this.translateText('landlordPortal.permissionFields.community')}
            >
              <PermissionField
                name="notices"
                label={this.translateText('landlordPortal.permissionFields.notices')}
                onChange={onChange}
              />
              <PermissionField
                name="amenities"
                label={this.translateText('landlordPortal.permissionFields.amenities')}
                onChange={onChange}
              />
              <PermissionField
                name="events"
                label={this.translateText('landlordPortal.permissionFields.calendar')}
                onChange={onChange}
              />
              <PermissionField
                name="parcels"
                label={this.translateText('landlordPortal.permissionFields.parcelDelivery')}
                onChange={onChange}
              />
              <PermissionField
                name="promotions"
                label={this.translateText('landlordPortal.permissionFields.promotions')}
                onChange={onChange}
              />
              <PermissionField
                name="surveys"
                label={this.translateText('landlordPortal.permissionFields.surveys')}
                onChange={onChange}
              />
              <PermissionField
                name="visitors"
                label={this.translateText('landlordPortal.permissionFields.visitors')}
                onChange={onChange}
              />
              <PermissionField
                name="logs"
                label={this.translateText('landlordPortal.permissionFields.logs')}
                onChange={onChange}
              />
            </PermissionHeader>

            <PermissionField
              name="properties"
              label={this.translateText('landlordPortal.permissionFields.properties')}
              onChange={onChange}
            />
            <PermissionField
              name="users"
              label={this.translateText('landlordPortal.permissionFields.users')}
              onChange={onChange}
            />
            {this.props.showMessaging && (
              <PermissionField
                name="messaging"
                label={this.translateText('landlordPortal.permissionFields.messaging')}
                onChange={onChange}
              />
            )}
            <PermissionHeader
              name={this.translateText('landlordPortal.permissionFields.selfServiceKiosk')}
            >
              <PermissionField
                name="calendar_kiosk"
                label={this.translateText('landlordPortal.permissionFields.calendar')}
                onChange={onChange}
              />
              <PermissionField
                name="parcels_kiosk"
                label={this.translateText('landlordPortal.permissionFields.parcels')}
                onChange={onChange}
              />
              <PermissionField
                name="maintenance_tickets_kiosk"
                label={serviceRequestOptions(serviceRequestsOptions)}
                onChange={onChange}
              />
            </PermissionHeader>
            <PermissionField
              name="company_settings"
              label={this.translateText('landlordPortal.permissionFields.companySettings')}
              onChange={onChange}
            />
          </div>
        </div>
      </div>
    );
  }
}

const PermissionField = ({ name, label, onChange, isChild }) => {
  let labelStyle = {
    fontSize: '15px',
    fontWeight: '800',
    fontFamily: 'Circular',
    padding: '16px 0px',
    margin: '0px 0px -5px 0px',
  };
  labelStyle = isChild ? { ...labelStyle, fontSize: '14px', fontWeight: '200' } : labelStyle;

  return (
    <div
      className="row"
      style={{
        padding: '0px 30px',
        fontSize: '14px',
        textAlign: 'left',
        borderBottom: !isChild ? `1px solid ${colors.LIGHT_GRAY}` : 'none',
      }}
    >
      <FormControlLabel
        style={{ justifyContent: 'space-between', width: '100%' }}
        labelPlacement="start"
        control={
          <Field
            name={name}
            component={Switch}
            onChange={onChange}
            normalize={v => !!v}
            color="primary"
          />
        }
        label={<p style={labelStyle}>{label}</p>}
      />
    </div>
  );
};

const PermissionHeader = ({ name, children }) => {
  return (
    <Collapsible
      style={{ borderBottom: `1px solid ${colors.LIGHT_GRAY}` }}
      header={
        <div className="row" style={{ textAlign: 'left' }}>
          <p
            style={{
              color: colors.DARK_GRAY,
              fontSize: '15px',
              padding: '16px 14px',
              margin: '0px',
              fontWeight: '800',
            }}
          >
            {name}
          </p>
        </div>
      }
    >
      {React.Children.map(children, child => React.cloneElement(child, { isChild: true }))}
    </Collapsible>
  );
};

export default localize()(PermissionFields);
